import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from "react";
import { Viewer3DFrame } from "./Viewer3DFrame";
/**
 * Renders configuration assembly in a 3D viewer
 *
 * @category Components
 */
export function Assembly3DViewer(props) {
    const { children } = props, viewerProps = __rest(props, ["children"]);
    return (_jsxs(Fragment, { children: [_jsx(Viewer3DFrame, Object.assign({}, viewerProps)), children] }));
}
//# sourceMappingURL=Assembly3DViewer.js.map